import cls from "classnames";
import { ReactComponent as ArrowIcon } from "logic/src/components/icons/arrowRight.svg";
import { ReactComponent as DeleteIcon } from "logic/src/components/icons/delete.svg";
import styles from "./index.module.scss";

export interface ILinkContent {
  sourceIcon?: string;
  source?: string;
  title?: string;
  url?: string;
  desc?: string;
  showArrow?: boolean;
  className?: string;
  titleCls?: string;
  descCls?: string;
  topCls?: string;
  onClick?: () => void;
  onDelete?: () => void;
}

const LinkPopover: React.FC<ILinkContent> = ({
  sourceIcon,
  source,
  title,
  url,
  desc,
  showArrow = true,
  className,
  titleCls,
  descCls,
  topCls,
  onClick,
  onDelete,
}) => {
  const handleUrlClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    !!url && window.open(url, "_blank");
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete?.();
  };

  const handleContainerClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick?.();
  };

  const showIcon = sourceIcon || source;
  const showTitle = title || !showIcon;

  return (
    <div
      className={cls(styles.container, className)}
      onClick={handleContainerClick}
    >
      {showIcon && (
        <div
          className={cls(styles.top, topCls)}
          style={{ paddingBottom: !title ? 6 : 3 }}
        >
          {sourceIcon && <img src={sourceIcon} className={styles.icon} />}
          <span className={styles.source}>{source}</span>
          {!showTitle && onDelete && (
            <DeleteIcon
              className={styles.deleteIcon}
              onClick={e => handleDelete(e)}
            />
          )}
        </div>
      )}

      {showTitle && (
        <div className={cls(styles.center, topCls)}>
          <span
            className={cls(styles.title, titleCls)}
            dangerouslySetInnerHTML={{ __html: title || "&nbsp;" }}
          ></span>

          {onDelete && (
            <DeleteIcon
              className={styles.deleteIcon}
              onClick={e => handleDelete(e)}
            />
          )}
        </div>
      )}

      {desc && (
        <div className={cls(styles.bottom, descCls)}>
          <div className={styles.desc}>{desc}</div>
        </div>
      )}
    </div>
  );
};
export default LinkPopover;
